// parse date
export const parseDate = (dateStr: any) => {
  if (!dateStr) return new Date(0);

  const parts = dateStr.split("-");

  // if first part is 4 digits => YYYY-MM-DD
  if (parts[0].length === 4) {
    return new Date(dateStr);
  }

  // otherwise DD-MM-YYYY
  return new Date(parts.reverse().join("-"));
};

// parse number
export const parseNumber = (num: any) => {
  if (!num) return 0;
  if (typeof num == "number") {
    return Number(num || "") || 0;
  }
  return Number((num || "").replace(/\D/g, "")) || 0;
};

// parse time i.e., 2h 20min or 30min
export const parseTiming = (time: any) => {
  if (!time) return 0;

  const hours = Number(time.match(/(\d+)h/)?.[1] || 0);
  const minutes = Number(time.match(/(\d+)m/)?.[1] || 0);

  return hours * 60 + minutes;
};

// parse Days i.e 12 days , 2 days
export const parseDaysString = (day: string) => {
  if (!day) return 0;
  return Number((day || "").match(/\d+/)?.[0]) || 0;
};


// safeLocaleCompare
export const safeLocaleCompare = <T>(
  a: T,
  b: T,
  key: keyof T
): number => {
  return String(a[key] ?? "").localeCompare(String(b[key] ?? ""));
};